mutation SupplierApprovalCreate($input: SupplierApprovalCreateInput!) {
  supplierApprovalCreate(input: $input) {
    approvalRequestResults {
      _status
      _isSubmitted
      entityId
    }
  }
}
